import { render, staticRenderFns } from "./webviewer-component.vue?vue&type=template&id=1bbc0a7e&scoped=true"
import script from "./webviewer-component.vue?vue&type=script&lang=js"
export * from "./webviewer-component.vue?vue&type=script&lang=js"
import style0 from "./webviewer-component.vue?vue&type=style&index=0&id=1bbc0a7e&prod&lang=scss"
import style1 from "./webviewer-component.vue?vue&type=style&index=1&id=1bbc0a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc0a7e",
  null
  
)

export default component.exports